import React from "react";

export function RowFlex(props) {
    const style = props.style || {};
    return (
        <div className="row" style={{ display: "flex", justifyContent: style.justifyContent || "flex-start", alignItems: "center", ...style }}>
            {props.children}
        </div>
    );
}
